import { CommonIcons, icons } from "../../../../components/common/CommonIcons"

const navConfig = [
  {
    title: 'dashboard',
    path: 'dashboard',
    icon: <CommonIcons name={icons.dashboard} />
  },
  {
    title: 'people',
    icon: <CommonIcons name={icons.users} />,
    children: [
      {
        title: "administrators",
        path: "users/administrators",
        allowOpenNew: true,
      },
      {
        title: "customers",
        path: "users/customers",
        allowOpenNew: true,
      },
      // {
      //   title: "suppliers",
      //   path: "users/suppliers",
      // },
      // {
      //   title: "Retailers",
      //   path: "users/retailers",
      // },
      // {
      //   title: 'drivers',
      //   path: 'users/drivers',
      // },
      {
        title: 'workers',
        path: 'users/workers',
        allowOpenNew: true,
      },
    ]
  },
  {
    title: 'products',
    icon: <CommonIcons name={icons.products} />,
    children: [
      {
        title: 'items',
        path: 'products/items',
        allowOpenNew: true,
      },
      // {
      //   title: 'categories',
      //   path: 'products/categories',
      // },
      // {
      //   title: 'brands',
      //   path: 'products/brands',
      // },
      // {
      //   title: 'uoms',
      //   path: 'products/uoms',
      // },
    ]
  },
  // {
  //   title: 'sales',
  //   icon: <CommonIcons name={icons.sales} />,
  //   children: [
  //     // {
  //     //   title: 'Sales Orders',
  //     //   path: 'documents/salesOrders'
  //     // },
  //     {
  //       title: 'salesInvoices',
  //       path: 'documents/salesInvoices'
  //     },
  //     // {
  //     //   title: 'Cash Sales',
  //     //   path: 'documents/cashSales'
  //     // },
  //     {
  //       title: 'deliveryOrders',
  //       path: 'documents/deliveryOrders'
  //     },
  //     // {
  //     //   title: 'Sales Debit Notes',
  //     //   path: 'documents/salesDebitNotes'
  //     // },
  //     // {
  //     //   title: 'Sales Credit Notes',
  //     //   path: 'documents/salesCreditNotes'
  //     // },
  //     // {
  //     //   title: 'Replacement Deliveries',
  //     //   path: 'documents/replacementDeliveries'
  //     // },
  //     // {
  //     //   title: 'Retail Cash Sales',
  //     //   path: 'documents/retailCashSales',
  //     // },
  //   ]
  // },
  // {
  //   title: 'parcel',
  //   icon: <CommonIcons name={icons.add} />,
  //   path: 'items/parcel/new',
  //   // children: [
  //   //   {
  //   //     title: 'Parcels',
  //   //     path: 'items/parcel/new'
  //   //   },
  //   // ]
  // },
  // {
  //   title: 'Purchases',
  //   icon: <CommonIcons name={icons.purchase} />,
  //   children: [
  //     {
  //       title: 'Purchase Orders',
  //       path: 'documents/purchaseOrders'
  //     },
  //     {
  //       title: 'Purchase Return',
  //       path: 'documents/purchaseReturns'
  //     },
  //     {
  //       title: 'Purchase Invoice',
  //       path: 'documents/purchaseInvoices'
  //     },
  //   ]
  // },
  // {
  //   title: 'warehouse',
  //   icon: <CommonIcons name={icons.warehouse} />,
  //   children: [
  //     {
  //       title: 'itemReceives',
  //       path: 'documents/itemReceives'
  //     },
  //     {
  //       title: 'itemTransfers',
  //       path: 'documents/itemTransfers'
  //     },
  //     // {
  //     //   title: 'Item Relocates',
  //     //   path: 'documents/itemRelocates'
  //     // },
  //     // {
  //     //   title: 'Item Transform',
  //     //   path: 'documents/itemTransform'
  //     // },
  //     // {
  //     //   title: 'Item Issues',
  //     //   path: 'documents/itemIssues'
  //     // },
  //     // {
  //     //   title: 'Item Adjustments',
  //     //   path: 'documents/itemAdjustments'
  //     // },
  //     // {
  //     //   title: 'Stock Takes',
  //     //   path: 'documents/stockTakes'
  //     // },
  //     // {
  //     //   title: 'Transfer Returns',
  //     //   path: 'documents/transferReturns'
  //     // },
  //     // {
  //     //   title: 'Transfer Requisitions',
  //     //   path: 'documents/transferRequisitions'
  //     // },
  //   ]
  // },
  // {
  //   title: 'logistics',
  //   icon: <CommonIcons name={icons.logistic} />,
  //   children: [
  //     {
  //       title: 'transporters',
  //       path: 'logistics/transporters'
  //     },
  //     {
  //       title: 'deliveryTrips',
  //       path: 'documents/tripOrders'
  //     },
  //   ]
  // },
  // {
  //   title: 'Others',
  //   icon: <CommonIcons name={icons.documents} />,
  //   children: [
  //     {
  //       title: 'Retail Prescriptions',
  //       path: 'documents/retailPrescriptions'
  //     },
  //     {
  //       title: 'Retail Cash Sales',
  //       path: 'documents/retailCashSales'
  //     },
  //   ]
  // },
  {
    title: 'repositories',
    path: '',
    icon: <CommonIcons name={icons.repository} />,
    children: [
      {
        title: 'containers',
        path: 'repositories/containers',
        allowOpenNew: true,
      },
      // {
      //   title: 'Packages',
      //   path: 'repositories/packages'
      // },
    ]
  },
  // {
  //   title: 'groups',
  //   path: '',
  //   icon: <CommonIcons name={icons.group} />,
  //   children: [
  //     {
  //       title: 'administratorGroups',
  //       path: 'groups/administrators'
  //     },
  //     {
  //       title: 'customerGroups',
  //       path: 'groups/customers'
  //     },
  //     // {
  //     //   title: 'Supplier',
  //     //   path: 'groups/suppliers'
  //     // },
  //   ]
  // },
  {
    title: 'reports',
    path: '',
    icon: <CommonIcons name={icons.report} />,
    children: [
      {
        title: 'products',
        path: 'reports/products',
      },
      {
        title: 'containers',
        path: 'reports/containers',
      },
      {
        title: 'productItems',
        path: 'reports/productItems',
      },
    ]
  },
  {
    title: 'settings',
    icon: <CommonIcons name={icons.setting} />,
    path: 'settings/userRoles',
    // children: [
    //   {
    //     title: 'rolesAndPermissions',
    //     path: 'settings/userRoles',
    //     allowOpenNew: true,
    //   },
    //   // {
    //   //   title: 'business',
    //   //   path: 'settings/business',
    //   // },
    //   {
    //     title: 'locations',
    //     path: 'settings/locations',
    //     allowOpenNew: true,
    //   },
    //   // {
    //   //   title: 'regions',
    //   //   path: 'settings/countries',
    //   // },
    //   // {
    //   //   title: 'Custom Fields',
    //   //   path: 'settings/customFields',
    //   // },
    //   {
    //     title: 'injectionProps',
    //     path: 'settings/injectionProps',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'shippingRates',
    //     path: 'settings/shippingRates',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'projectProps',
    //     path: 'configuration',
    //     allowOpenNew: true,
    //   },
    // ]
  },
  // {
  //   title: 'Demo DataGrid',
  //   icon: <CommonIcons name={icons.products} />,
  //   path: 'demodatagrid'
  // }
  // {
  //   title: 'schedulers',
  //   path: '',
  //   icon: <CommonIcons name={icons.schedule} />,
  //   children: [
  //     {
  //       title: 'tasks',
  //       path: 'scheduler/tasks',
  //       allowOpenNew: true,
  //     },
  //     {
  //       title: 'logs',
  //       path: 'scheduler/logs',
  //       allowOpenNew: true,
  //     },
  //     {
  //       title: 'requests',
  //       path: 'scheduler/requests',
  //       allowOpenNew: true,
  //     },
  //     {
  //       title: 'console',
  //       path: 'scheduler/console',
  //       allowOpenNew: true,
  //     },
  //   ]
  // },
];

export default navConfig;
